import { useContext } from 'react';
import { AppContext } from '../modules/app';
export default (function () {
  return useContext(AppContext);
});